import { Button, Group, Loader, TextInput } from "@mantine/core";
import { useDebouncedCallback } from "@mantine/hooks";
import { useState, type FC } from "react";

export interface IDataGridFilter {
    search: string;
    showInactive: boolean;
}

export interface IDataGridFilterProps {
    filter: IDataGridFilter;
    hideActiveToggle?: boolean;
    hideFilter?: boolean;
    activeLabel?: string;
    debounceMs?: number;
    onFilter?: (formFilter: IDataGridFilter) => void;
}

const defaultOnFilter = (_filter: IDataGridFilter) => {};

const DataGridFilter: FC<IDataGridFilterProps> = ({
    filter,
    onFilter = defaultOnFilter,
    hideActiveToggle,
    hideFilter,
    activeLabel,
    debounceMs
}) => {
    const showLabel = activeLabel && activeLabel != "" ? "Show " + activeLabel : "Show Inactive";
    const hideLabel = activeLabel && activeLabel != "" ? "Hide " + activeLabel : "Hide Inactive";

    const [searching, setSearching] = useState(false);

    const endSearch = useDebouncedCallback(() => setSearching(false), debounceMs ?? 0)

    return (
        <Group component="span" gap="xs" display="inline-flex" align="center">
            {!hideFilter && (
                <TextInput
                    placeholder="Filter..."
                    name="filter"
                    id="filter.search"
                    w={200}
                    value={filter.search}
                    onChange={(e) => {
                        setSearching(true);

                        let newFilter = { ...filter };
                        newFilter.search = e.target.value;
                        onFilter(newFilter);

                        endSearch();
                    }}
                    rightSection={
                        searching && (
                            <Loader size={16} />
                        )
                    }
                />
            )}
            {!hideActiveToggle && (
                <Button
                    onClick={() => {
                        setSearching(true);

                        let newFilter = { ...filter };
                        newFilter.showInactive = !newFilter.showInactive;
                        onFilter(newFilter);

                        endSearch();
                    }}
                    type="button"
                    variant="outline"
                >
                    {filter.showInactive ? hideLabel : showLabel}
                </Button>
            )}
        </Group>
    );
};

export default DataGridFilter;
